import { some } from '@utils/some';
import { mapToObject } from './mapToObject';

/**
 *
 * Create an object from a source object,
 *
 * picking keys of the original,
 *
 * to create an object picking those keys, with a new typing also picking those keys
 *
 * @param obj Target object
 * @param pickedKeys Keys of the target object to be picked from the return object
 */
export const pick = <T, PickedKey extends keyof T>(
  obj: T,
  ...pickedKeys: PickedKey[]
): Pick<T, PickedKey> => {
  if (!obj) return obj;

  const rtn = mapToObject(
    Object.keys(obj).filter((key) => some(pickedKeys || [], (k) => k == key)),
    (key) => ({
      [key]: obj[key],
    })
  );

  return rtn as Pick<T, PickedKey>;
};
